import { GhgEmissionCalculationMaterial } from '../GhgEmissionCalculationMaterial'
import { calcTonkloCo2Emission, getTonkiloGasEmissionMap } from './calcTonkiloEmission'
import { calcModifiedTonkiloCo2Emission, getModifiedTonkiloEmissionMap } from './calcModifiedTonkilo'
import { calcFuelEfficiencyCo2Emission, getFuelEfficiencyEmissionMap } from './calcFuelEfficiencyEmission'
import { calcFuelCo2Emission, getFuelEmissionMap } from './calcFuelEmission'

export const getGhgEmissionMap = (calcMaterial: GhgEmissionCalculationMaterial) => {
  switch (calcMaterial.calculationType) {
    case 'tonkilo':
      return getTonkiloGasEmissionMap(calcMaterial)
    case 'modifiedTonkilo':
      return getModifiedTonkiloEmissionMap(calcMaterial)
    case 'fuel':
      return getFuelEmissionMap(calcMaterial)
    case 'fuelEfficiency':
      return getFuelEfficiencyEmissionMap(calcMaterial)
    default: {
      throw Error('not supported yet')
    }
  }
}

export const calcCo2Emission = (calcMaterial: GhgEmissionCalculationMaterial) => {
  switch (calcMaterial.calculationType) {
    case 'tonkilo':
      return calcTonkloCo2Emission(calcMaterial)
    case 'modifiedTonkilo':
      return calcModifiedTonkiloCo2Emission(calcMaterial)
    case 'fuel':
      return calcFuelEfficiencyCo2Emission(calcMaterial)
    case 'fuelEfficiency':
      return calcFuelCo2Emission(calcMaterial)
    default: {
      throw Error('not supported yet')
    }
  }
}

export default getGhgEmissionMap
